import PropTypes from "prop-types";
import React from "react";

import {
  Avatar,
  Button,
  MessageTile as UIMessageTile,
  Person,
  ThemeSelector,
  Typography,
  withStyles
} from "@theconversation/ui";

const MessageTile = withStyles(theme => ({
  box: {
    marginBottom: 0,
    padding: theme.spacing(3),
  },
}))(UIMessageTile);

/**
 * The `EndOfArticle` component represents promos that are rendered at the
 * bottom of an article.
 */
function EndOfArticle({ title, body, person, donateText, buttonText, onClick, theme }) {
  // Some promos are using donateText, which is a bit too linked
  // to donations only. we should support `donateText` until we can only support `buttonText`
  const btnText = donateText || buttonText;

  return (
    <ThemeSelector theme={theme}>
      <MessageTile>
        <Typography variant="h6" gutterBottom>{title}</Typography>
        <Typography variant="body1" paragraph>{body}</Typography>

        <Typography paragraph>
          <Button prominent colour="primary" fullWidth={false} onClick={onClick}>
            {btnText}
          </Button>
        </Typography>

        <Typography gutterBottom>
          <Person name={person.name} caption={person.caption} />
        </Typography>
        { person.avatar && <Avatar size={48} src={person.avatar} /> }
      </MessageTile>
    </ThemeSelector>
  );
}

EndOfArticle.defaultProps = {
  buttonText: "",
  donateText: "",
  theme: "core",
};

EndOfArticle.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  person: PropTypes.shape({
    avatar: PropTypes.string,
    caption: PropTypes.string,
    name: PropTypes.string.isRequired,
  }).isRequired,
  buttonText: PropTypes.string,
  donateText: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  theme: PropTypes.string,
};

export default EndOfArticle;
